// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

let React = require("react");
let UserSession = require("../../reason/common/UserSession/UserSession.bs.js");
let Stdlib_JsError = require("@rescript/runtime/lib/js/Stdlib_JsError.js");
let IsNewQueryParam = require("./IsNewQueryParam.bs.js");
let Primitive_option = require("@rescript/runtime/lib/js/Primitive_option.js");
let RescriptRelay_Fragment = require("rescript-relay/src/RescriptRelay_Fragment.bs.js");
let MarketingProfileSubpages_marketingProfile_graphql = require("../../__generated__/MarketingProfileSubpages_marketingProfile_graphql.bs.js");

function path(page) {
  switch (page) {
    case "BasicInfo" :
      return "/account/marketing_profile/basic_info";
    case "Photos" :
      return "/account/marketing_profile/photos";
    case "Bio" :
      return "/account/marketing_profile/about";
    case "SocialMedia" :
      return "/account/marketing_profile/social_media";
    case "Url" :
      return "/account/marketing_profile/url";
  }
}

function displayName(hasFullProfile, page) {
  switch (page) {
    case "BasicInfo" :
      return "Basic Info";
    case "Photos" :
      if (hasFullProfile) {
        return "Profile Picture & Featured Portrait";
      } else {
        return "Profile Picture";
      }
    case "Bio" :
      return "About You";
    case "SocialMedia" :
      return "Social Media";
    case "Url" :
      return "Custom profile URL";
  }
}

function useDisplayName() {
  let hasFullProfile = UserSession.useHasPlanFeature("FULL_AGENT_PAGE");
  return React.useCallback(page => displayName(hasFullProfile, page), [hasFullProfile]);
}

let Agent = {
  path: path,
  displayName: displayName,
  useDisplayName: useDisplayName
};

function path$1(page) {
  switch (page) {
    case "BasicInfo" :
      return "/account/team_marketing_profile/basic_info";
    case "Photos" :
      return "/account/team_marketing_profile/photos";
    case "About" :
      return "/account/team_marketing_profile/about";
    case "SocialMedia" :
      return "/account/team_marketing_profile/social_media";
    case "Members" :
      return "/account/team_marketing_profile/members";
    case "Url" :
      return "/account/team_marketing_profile/url";
  }
}

function displayName$1(hasFullProfile, page) {
  switch (page) {
    case "BasicInfo" :
      return "Basic Info";
    case "Photos" :
      if (hasFullProfile) {
        return "Logo and team photo";
      } else {
        return "Logo";
      }
    case "About" :
      return "About";
    case "SocialMedia" :
      return "Social Media";
    case "Members" :
      return "Members";
    case "Url" :
      return "Custom profile URL";
  }
}

function useDisplayName$1() {
  let hasFullProfile = UserSession.useHasPlanFeature("FULL_AGENT_PAGE");
  return React.useCallback(page => displayName$1(hasFullProfile, page), [hasFullProfile]);
}

let Team = {
  path: path$1,
  displayName: displayName$1,
  useDisplayName: useDisplayName$1
};

let Page = {
  Agent: Agent,
  Team: Team
};

function teamPageToPageData(hasFullProfile, page) {
  let displayName$2 = displayName$1(hasFullProfile, page);
  let path$2 = path$1(page);
  return {
    page: page,
    displayName: displayName$2,
    path: path$2
  };
}

function useTeamProfilePages(isNewOpt, param) {
  let isNew = isNewOpt !== undefined ? isNewOpt : false;
  let hasFullProfile = UserSession.useHasPlanFeature("FULL_AGENT_PAGE");
  let match = IsNewQueryParam.use();
  let isNew$p = match[0] || isNew;
  let pages = hasFullProfile ? (
      isNew$p ? [
          "BasicInfo",
          "Url",
          "Photos",
          "About",
          "SocialMedia",
          "Members"
        ] : [
          "BasicInfo",
          "Photos",
          "About",
          "SocialMedia",
          "Members",
          "Url"
        ]
    ) : [
      "BasicInfo",
      "Photos",
      "Members"
    ];
  return pages.map(page => teamPageToPageData(hasFullProfile, page));
}

function agentPageToPageData(hasFullProfile, page) {
  let displayName$2 = displayName(hasFullProfile, page);
  let path$2 = path(page);
  return {
    page: page,
    displayName: displayName$2,
    path: path$2
  };
}

function useAgentProfilePages() {
  let hasFullProfile = UserSession.useHasPlanFeature("FULL_AGENT_PAGE");
  let pages = hasFullProfile ? [
      "BasicInfo",
      "Photos",
      "Bio",
      "SocialMedia",
      "Url"
    ] : [
      "BasicInfo",
      "Photos"
    ];
  return pages.map(page => agentPageToPageData(hasFullProfile, page));
}

let convertFragment = MarketingProfileSubpages_marketingProfile_graphql.Internal.convertFragment;

function waitForFragmentData(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, MarketingProfileSubpages_marketingProfile_graphql.node, convertFragment, fRef);
}

function use(fRef) {
  return RescriptRelay_Fragment.useFragment(MarketingProfileSubpages_marketingProfile_graphql.node, convertFragment, fRef);
}

function useOpt(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Primitive_option.some(Primitive_option.valFromOption(fRef)) : undefined, MarketingProfileSubpages_marketingProfile_graphql.node, convertFragment);
}

function readResolverFragment(fRef) {
  return RescriptRelay_Fragment.read(MarketingProfileSubpages_marketingProfile_graphql.node, convertFragment, fRef);
}

let Fragment = {
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment,
  waitForFragmentData: waitForFragmentData,
  use: use,
  useOpt: useOpt,
  readResolverFragment: readResolverFragment
};

function useSubpagesForCurrentAccount(marketingProfile) {
  let marketingProfile$1 = useOpt(marketingProfile);
  if (marketingProfile$1 === undefined) {
    return;
  }
  let match = marketingProfile$1.__typename;
  let marketingProfileType;
  switch (match) {
    case "AgentMarketingProfile" :
      marketingProfileType = "AgentProfile";
      break;
    case "TeamMarketingProfile" :
      marketingProfileType = "TeamProfile";
      break;
    default:
      marketingProfileType = Stdlib_JsError.throwWithMessage("Invalid marketing profile type");
  }
  let agentPages = useAgentProfilePages();
  let teamPages = useTeamProfilePages(undefined, undefined);
  if (marketingProfileType === "AgentProfile") {
    return {
      TAG: "AgentPages",
      _0: agentPages
    };
  } else {
    return {
      TAG: "TeamPages",
      _0: teamPages
    };
  }
}

exports.Page = Page;
exports.teamPageToPageData = teamPageToPageData;
exports.useTeamProfilePages = useTeamProfilePages;
exports.agentPageToPageData = agentPageToPageData;
exports.useAgentProfilePages = useAgentProfilePages;
exports.Fragment = Fragment;
exports.useSubpagesForCurrentAccount = useSubpagesForCurrentAccount;
/* react Not a pure module */
